var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRemoveIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#C82135",
  d: "M4.875 14.525 7 12.4l2.125 2.125 1.4-1.4L8.4 11l2.15-2.125-1.425-1.4L7 9.6 4.875 7.475l-1.4 1.4L5.6 11l-2.125 2.125zM0 3V1h3.5l1-1h5l1 1H14v2zm3 15q-.824 0-1.412-.587A1.93 1.93 0 0 1 1 16V4h12v12q0 .825-.587 1.413A1.93 1.93 0 0 1 11 18z"
})));
export { SvgRemoveIcon as ReactComponent };
export default __webpack_public_path__ + "static/media/remove-icon.1bd8d11f.svg";